// import React, { useEffect, useState } from "react";
// import Modal from "react-bootstrap/Modal";
// import { Button, Tab, Tabs } from "react-bootstrap";
// import swal from "sweetalert";
// import { useForm } from "react-hook-form";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addTimelineAction,
//   deleteAcccountReducerAction,
//   deleteDataUsingFormData,
//   ExportDownloadReducerAction,
//   ExportXLSXDownloadReducerAction,
//   ExportZipDownloadReducerAction,
//   FetchSingleRecordAction,
//   getMOPInstructionAction,
//   popUpUpdate,
// } from "../../../../store/actions/createTicketManageFields";
// import {
//   addSiteTimelineData,
//   mobileDatacoptl,
// } from "../../../../common/config";
// import SiteTimeLineForm from "../Site Timeline Form/SiteTimeLineForm";
// import { Link } from "@mui/material";
// import SiteTimelineCommentEdit from "../Site Timeline Comment Edit/SiteTimelineCommentEdit";
// import SiteTimelineCDU from "./SiteTimelineCDU";
// import SiteTimelineTableuADPF from "./SiteTimelineuADPF";
// // import SiteTimelineCommentEdit from '../Site Timeline Comment Edit/SiteTimelineCommentEdit';

// const SiteTimelineTable = ({
//   ranSupportItem = "",
//   setcommonModalState,
//   setSiteTimelineTable,
//   siteTimelineTable,
//   Header,
//   modalSize = "xl",
// }) => {
//   // edit Time in Site timeLine Data logic start here
//   const[siteTimelineCDU,seSitmeLineCDU] = useState(false)
//   const[siteTimelineUPDF,seSitmeLineUPDF] = useState(false)

//   return (
//     <>

//     <SiteTimelineCDU ranSupportItem={ranSupportItem} siteTimelineTable={siteTimelineCDU} setSiteTimelineTable={seSitmeLineCDU} modalSize="xl" Header="Site Timeline CDU"/>
//     <SiteTimelineTableuADPF ranSupportItem={ranSupportItem} siteTimelineTable={siteTimelineUPDF} setSiteTimelineTable={seSitmeLineUPDF} modalSize="xl" Header="Site Timeline UPDF"/>

//     <Modal
//         size={modalSize ? modalSize : "xl"}
//         show={siteTimelineTable}
//         onHide={() => setSiteTimelineTable(false)}
//         aria-labelledby="example-modal-sizes-title-xl"
//         backdrop="static"
//       >
//         <Modal.Header className="CommonModalHeader">
//           <Modal.Title id="example-modal-sizes-title-xl ">
//             <h4 className="CommonModalHeaderHeading">{Header}</h4>
//             <Button
//               variant=""
//               className="close CommonModalClose"
//               onClick={() => {
//                 setSiteTimelineTable(false);
//               }}
//             >
//               <span className="CommonModalClose">&times;</span>
//             </Button>
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body
//           style={{ backgroundColor: "white", padding: "0px !important" }}
//         >
//           <>
//           <div style={{display:'flex',gap:"10px"}} className="py-3 d-flex justify-content-center align-items-center">
//                 <button onClick={()=>{
//                   seSitmeLineCDU(true)
//                   seSitmeLineUPDF(false)
//                 }}  className="btn btn-primary btn-xs ">
//                   Site Timeline CDU
//                 </button>
//                 <button
//                 onClick={()=>{
//                   seSitmeLineCDU(false)
//                   seSitmeLineUPDF(true)
//                 }}
//                  className="btn btn-primary btn-xs ">
//                   Site Timeline uAPDF
//                 </button>
//               </div>
//           </>
//         </Modal.Body>
//       </Modal>

//     </>
//   )

// };

// export default SiteTimelineTable;

// ///////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Tab, Tabs } from "react-bootstrap";
import swal from "sweetalert";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  addTimelineAction,
  deleteAcccountReducerAction,
  deleteAcccountReducerAction2,
  deleteDataUsingFormData,
  ExportDownloadReducerAction,
  ExportXLSXDownloadReducerAction,
  ExportZipDownloadReducerAction,
  FetchSingleRecordAction,
  FetchSingleRecordAction2,
  getMOPInstructionAction,
  popUpUpdate,
} from "../../../../store/actions/createTicketManageFields";
import {
  addSiteTimelineData,
  mobileDatacoptl,
} from "../../../../common/config";
import SiteTimeLineForm from "../Site Timeline Form/SiteTimeLineForm";
import { Link } from "@mui/material";
import SiteTimelineCommentEdit from "../Site Timeline Comment Edit/SiteTimelineCommentEdit";
// import addSiteTimelineReduce
// import SiteTimelineCommentEdit from '../Site Timeline Comment Edit/SiteTimelineCommentEdit';

const SiteTimelineTable = ({
  ranSupportItem = "",
  setcommonModalState,
  setSiteTimelineTable,
  siteTimelineTable,
  Header,
  modalSize = "xl",
}) => {
  // edit Time in Site timeLine Data logic start here
  const [editSiteTimelineTime, setEditSiteTimelineTime] = useState(false);
  const [activityTimeline, setActivityTimeline] = useState("");
  const [editSiteTimelineComment, setEditSiteTimelineComment] = useState(false);
  const [activityTimelineOptions, setActivityTimelineOptions] = useState([]);
  const [activityTimeId, setActivityTimeId] = useState("");
  const [commonModalStateTimeline, setcommonModalStateTimeline] =
    useState(false);
  const [tab, setTab] = useState("Site Timeline CDU");
  const [type, setType] = useState("CDU");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    formState: { errors },
  } = useForm({});

  const timeLineData = watch("team");

  const FETimeline = [
    "LOGIN TIME",
    "Precheck Request",
    "FSU ENV Script Load",
    "Stationary Test Start",
    "Stationary Test Start (LTE)",
    "Stationary Test Finish (LTE)",
    "Stationary Test Start (5G-NR850 LS3 - vDU)",
    "Stationary Test Finish (5G-NR850 LS3 - vDU)",
    "Mobility test Start",
    "Mobility test Complete",
  ];

  const GCTimeline = [
    "GC Contacted VZN to Lock Nokia",
    "TN Fiber Swap from Nokia to CDU",
    "Postcheck request",
  ];

  const IXTimeline = [
    "Precheck Complete",
    "FSU GROW Start",
    "FSU GROW Finish",
    "CDU ENV Script Load (Pseudo IP)",
    "CREATE NE Script Load Start",
    "CREATE NE Script Load Finish",
    "CDU CREATE CELLS Script Load",
    "CDU POST XML Script Load",
    "SW and Firmware Upgrade",
    "Pseudo IP Change",
    "HIGH BAND UNLOCKED & TAKING TRAFFIC",
    "RETs Scanned for Highband",
    "Low Band Radios connected at FSU",
    "ALL BANDS UP AND TAKING TRAFFIC W/NO ALARMS",
    "All RETs scanned & userlabel/sector ID Updated",
    "vDU IX Process Start",
    "Script creation & validation",
    "Script execution Start",
    "Script execution Complete",
    "vDU IX Process Finish",
    "Postcheck complete",
    "vDU UP, ALL CELLS ENABLED & TAKING TRAFFIC",
    "Final Postchecks start",
    "Final Postchecks finish",
  ];

  const RFTimeline = [
    "Stationary Test Validation Start",
    "Stationary Test Validation Finish",
    "Mobility test validation Start",
    "Mobility test validation Finish",
    "ATP Report Generation Start",
    "ATP Report Generation Finish",
  ];

  // const timelineDataTable = [
  //   { id: 1, team: "FE", activity: "LOGIN TIME" },
  //   { id: 2, team: "FE", activity: "Precheck Request" },
  //   { id: 3, team: "IX", activity: "Precheck Complete" },
  //   { id: 4, team: "FE", activity: "FSU ENV Script Load" },
  //   { id: 5, team: "IX", activity: "FSU GROW Start" },
  //   { id: 5.1, team: "IX", activity: "FSU GROW Finish" },
  //   { id: 6, team: "IX", activity: "CDU ENV Script Load (Pseudo IP)" },
  //   { id: 7, team: "IX", activity: "CREATE NE Script Load Start" },
  //   { id: 7.1, team: "IX", activity: "CREATE NE Script Load Finish" },
  //   { id: 8, team: "IX", activity: "CDU CREATE CELLS Script Load" },
  //   { id: 9, team: "IX", activity: "CDU POST XML Script Load" },
  //   { id: 10, team: "IX", activity: "SW and Firmware Upgrade" },
  //   { id: 11, team: "IX", activity: "Pseudo IP Change" },
  //   { id: 11.1, team: "GC", activity: "GC Contacted VZN to Lock Nokia" },
  //   { id: 11.2, team: "GC", activity: "TN Fiber Swap from Nokia to CDU" },
  //   { id: 12, team: "IX", activity: "HIGH BAND UNLOCKED & TAKING TRAFFIC" },
  //   { id: 13, team: "IX", activity: "RETs Scanned for Highband" },
  //   { id: 14, team: "IX", activity: "Low Band Radios connected at FSU" },
  //   { id: 15, team: "IX", activity: "ALL BANDS UP AND TAKING TRAFFIC W/NO ALARMS" },
  //   { id: 16, team: "IX", activity: "All RETs scanned & userlabel/sector ID Updated" },
  //   { id: 17, team: "IX", activity: "vDU IX Process Start" },
  //   { id: 17.1, team: "IX", activity: "Script creation & validation" },
  //   { id: 17.2, team: "IX", activity: "Script execution Start" },
  //   { id: 17.3, team: "IX", activity: "Script execution Complete" },
  //   { id: 17.4, team: "IX", activity: "vDU IX Process Finish" },
  //   { id: 18, team: "FE", activity: "Stationary Test Start" },
  //   { id: 18.1, team: "FE", activity: "Stationary Test Start (LTE)" },
  //   { id: 18.2, team: "FE", activity: "Stationary Test Finish (LTE)" },
  //   { id: 18.3, team: "FE", activity: "Stationary Test Start (5G-NR850 LS3 - vDU)" },
  //   { id: 18.4, team: "FE", activity: "Stationary Test Finish (5G-NR850 LS3 - vDU)" },
  //   { id: 19, team: "RF", activity: "Stationary Test Validation Start" },
  //   { id: 19.1, team: "RF", activity: "Stationary Test Validation Finish" },
  //   { id: 20, team: "GC", activity: "Postcheck request" },
  //   { id: 21, team: "IX", activity: "Postcheck complete" },
  //   { id: 22, team: "IX", activity: "vDU UP, ALL CELLS ENABLED & TAKING TRAFFIC" },
  //   { id: 23, team: "IX", activity: "Final Postchecks start" },
  //   { id: 23.1, team: "IX", activity: "Final Postchecks finish" },
  //   { id: 24, team: "FE", activity: "Mobility test Start" },
  //   { id: 24.1, team: "FE", activity: "Mobility test Complete" },
  //   { id: 25, team: "RF", activity: "Mobility test validation Start" },
  //   { id: 25.1, team: "RF", activity: "Mobility test validation Finish" },
  //   { id: 26, team: "RF", activity: "ATP Report Generation Start" },
  //   { id: 26.1, team: "RF", activity: "ATP Report Generation Finish" },
  // ];

  let zeroIndexTime = "";

  useEffect(
    () => [
      setTimeout(() => {
        dispatch(
          FetchSingleRecordAction2(
            addSiteTimelineData,
            ranSupportItem["ranSupportId"],
            type
          )
        );
      }, 2000),
    ],
    [editSiteTimelineComment, editSiteTimelineTime, commonModalStateTimeline]
  );

  useEffect(() => {
    if (timeLineData === "FE") {
      setActivityTimelineOptions(FETimeline);
    } else if (timeLineData === "GC") {
      setActivityTimelineOptions(GCTimeline);
    } else if (timeLineData === "IX") {
      setActivityTimelineOptions(IXTimeline);
    } else if (timeLineData === "RF") {
      setActivityTimelineOptions(RFTimeline);
    }

    console.log(activityTimelineOptions, "____activityTimelineOptions");
  }, [timeLineData]);
  const [idAndOrder, setIdAndOrder] = useState({
    previousId: "",
    order: "",
  });
  const dispatch = useDispatch();
  const deleteSiteTimeline = async (id, timelineId, types) => {
    // Store the ranSupportId in localStorage
    localStorage.setItem("ranSupportId", ranSupportItem["ranSupportId"]);
  
    const willDelete = await swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
  
    if (willDelete) {
      try {
       
        await dispatch(
          deleteAcccountReducerAction2(addSiteTimelineData + "/" + id, timelineId, types)
        );
  
        await dispatch(
          FetchSingleRecordAction2(addSiteTimelineData, ranSupportItem["ranSupportId"], types)
        );
  
        
        console.log("Timeline deleted and data refreshed.");
      } catch (error) {
        
        console.error("Error deleting timeline:", error);
        swal("Error!", "Something went wrong. Please try again.", "error");
      }
    }
  };
  const siteTimeline = useSelector((state) => {
    let timelineData = state.CommonResponse.addSiteTimelineData;
    return { timelineData };
  });

  let odata = siteTimeline?.timelineData?.map((oneitm, index) => {
    // const timeOnly = new Date(oneitm.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const dateObj = new Date(oneitm.time);
    const timeOnly = dateObj.toLocaleTimeString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
    });

    if (oneitm === 0) {
      zeroIndexTime = timeOnly;
    }
    // if(index !== 0){
    return (
      <>
        <tr>
          <td
            style={{
              width: "30%;",
              paddingTop: "11px",
              fontSize: "13px",
              height: "45px",
              border: "2px solid black",
            }}
          >
            {oneitm?.order}
          </td>
          <td
            style={{
              width: "30%;",
              paddingTop: "11px",
              fontSize: "13px",
              height: "45px",
              border: "2px solid black",
            }}
          >
            {oneitm.team}
          </td>
          <td
            style={{
              width: "30%;",
              paddingTop: "11px",
              fontSize: "13px",
              height: "45px",
              border: "2px solid black",
            }}
          >
            {oneitm.activityTimeline}
          </td>
          {/* <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
          <button
          onClick={(e) => { setEditSiteTimelineTime(true);
            let id = siteTimeline?.timelineData[0]?.parentId+"/"+oneitm._id;
            setActivityTimeId(id);
            // setActivityTimeId(siteTimeline?.timelineData[0]?.parentId); 
            setActivityTimeline(oneitm.activityTimeline)
            console.log(oneitm?.parentId,"____parentId______")}}
                className="badge badge-success p-2"
                style={{ fontSize: "10px", lineHeight: "13px" }}
              >
                 {oneitm?.time }
              </button>
           
          </td>
           */}
          <td
            style={{
              width: "30%",
              paddingTop: "11px",
              fontSize: "13px",
              height: "45px",
              border: "2px solid black",
            }}
          >
            <button
              onClick={(e) => {
                localStorage.setItem("activityTimeId", activityTimeId);
                setEditSiteTimelineTime(true);
                let id =
                  siteTimeline?.timelineData[0]?.parentId + "/" + oneitm._id;
                setActivityTimeId(id);
                setActivityTimeline(oneitm.activityTimeline);
                console.log(oneitm?.parentId, "____parentId______");
              }}
              className="badge badge-success p-2"
              style={{ fontSize: "10px", lineHeight: "13px" }}
            >
              {oneitm?.time && !isNaN(new Date(oneitm.time))
                ? (() => {
                    const date = new Date(oneitm.time);
                    const formattedDate = date.toLocaleDateString("en-US", {
                      month: "2-digit",
                      day: "2-digit",
                      year: "numeric",
                    });
                    const formattedTime = date.toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    });
                    return `${formattedDate} ${formattedTime} CST`;
                  })()
                : "Select Time"}
            </button>
          </td>

          <td
            style={{
              width: "30%;",
              paddingTop: "11px",
              fontSize: "13px",
              height: "45px",
              border: "2px solid black",
            }}
          >
            <button
              onClick={(e) => {
                const id =
                  siteTimeline?.timelineData[0]?.parentId + "/" + oneitm._id;
                setActivityTimeId(id);
                setActivityTimeline(oneitm.activityTimeline);

                setEditSiteTimelineComment(true);
                console.log(oneitm?._id, "_oneitm____");
                // setId((oneitm)=>
                //   oneitm?._id);
                // setIdAndOrder(()=>{
                //   return {
                //     order:oneitm?.order,
                //     id:oneitm?._id
                //   }
                // })
                // setActivityTimeId(siteTimeline?.timelineData[0]?.parentId);

                console.log(oneitm?.parentId, "____parentId______");
              }}
              className="badge badge-success p-2"
              style={{ fontSize: "10px", lineHeight: "13px" }}
            >
              {oneitm.comment ? oneitm.comment : "No Comment"}
            </button>
          </td>
          <td
            style={{
              width: "30%;",
              paddingTop: "11px",
              fontSize: "13px",
              height: "45px",
              border: "2px solid black",
            }}
          >
            <div
              style={{ display: "inline-flex", gap: "5px", marginLeft: "5px" }}
            >
              <button
                onClick={(e) => {
                  setValue("activityTimeline", "");
                  setValue("comment", "");
                  setValue("team", "");
                  setcommonModalStateTimeline(true);

                  setIdAndOrder(() => {
                    return {
                      order: oneitm?.order,
                      previousId: oneitm?._id,
                    };
                  });
                }}
                className="badge badge-success p-2"
                style={{ fontSize: "10px", lineHeight: "13px" }}
              >
                +
              </button>

              <Link
                href="#"
                className="btn btn-danger shadow btn-xs sharp d-flex justify-content-center align-items-center p-2"
                // onClick={() => deleteSiteTimeline(oneitm.parentId, oneitm?._id?.$oid)}
                onClick={() => deleteSiteTimeline(oneitm.parentId, oneitm?._id,type)}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </td>
        </tr>
      </>
    );
    // }
  });

  const onSubmit = async (data) => {
    data = {
      ...data,
      previousId: idAndOrder?.previousId,
      order: idAndOrder?.order,
    };

    dispatch(
      addTimelineAction(
        addSiteTimelineData +
          "/" +
          ranSupportItem["ranSupportId"] +
          `?type=${type}`,
        data
      )
    );

    // setcommonModalState(false)
    setcommonModalStateTimeline(false);
    dispatch(
      FetchSingleRecordAction2(mobileDatacoptl, ranSupportItem["ranSupportId"])
    );
    // setTimeout(()=>{
    //   window.location.reload();
    // },4000)
  };

  return (
    <>
      <SiteTimeLineForm
        setcommonModalStateTimeline={setcommonModalStateTimeline}
        activityTimeline={activityTimeline}
        activityTimeId={activityTimeId}
        modalSize="md"
        Header="Edit Time"
        editSiteTimelineTime={editSiteTimelineTime}
        setEditSiteTimelineTime={setEditSiteTimelineTime}
        type={type}
      />

      <SiteTimelineCommentEdit
        setcommonModalStateTimeline={setcommonModalStateTimeline}
        activityTimeline={activityTimeline}
        activityTimeId={activityTimeId}
        modalSize="md"
        Header="Edit Comment"
        editSiteTimelineComment={editSiteTimelineComment}
        setEditSiteTimelineComment={setEditSiteTimelineComment}
        type={type}
      />

      {/* Add site TImeline modal starts here */}
      <Modal
        size={"md"}
        show={commonModalStateTimeline}
        onHide={() => setcommonModalStateTimeline(false)}
        aria-labelledby="example-modal-sizes-title-xl"
        backdrop="static"
      >
        <Modal.Header className="CommonModalHeader">
          <Modal.Title id="example-modal-sizes-title-xl ">
            <h4 className="CommonModalHeaderHeading">Add Site Timeline</h4>
            <Button
              variant=""
              className="close CommonModalClose"
              onClick={() => {
                setcommonModalStateTimeline(false);
              }}
            >
              <span className="CommonModalClose">&times;</span>
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ backgroundColor: "white", padding: "0px !important" }}
        >
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">
                  Team<span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: "32px" }}
                  className="form-control"
                  id="exampleFormControlSelect1"
                  placeholder="None Selected"
                  {...register("team")}
                >
                  <option value={""}>--None Selected--</option>
                  <option value={"GC"}>GC</option>
                  <option value={"IX"}>IX</option>
                  <option value={"FE"}>FE</option>
                  <option value={"RF"}>RF</option>
                </select>
              </div>

              <div className="form-group w-1/2">
                <label for="exampleFormControlSelect1">Activity Timeline</label>

                <input
                  style={{ height: "32px" }}
                  type="text"
                  className="form-control"
                  id="inputEmail4"
                  defaultValue={""}
                  name="activityTimeline"
                  {...register("activityTimeline")}
                />

                {errors.activityTimeline && (
                  <p className="error">{errors.activityTimeline.message}</p>
                )}
              </div>
              <div className="form-group col-md-3">
                <label for="exampleFormControlSelect1">Comment</label>
                <input
                  className="form-control"
                  style={{ height: "32px" }}
                  placeholder="Comment Here"
                  {...register("comment", {
                    // required: "Please Enter a Comment",
                    // pattern: {
                    //   // value: /^\d{8}$/,
                    //   message: "Please Enter a Comment"
                    // }
                  })}
                />

                {errors.comment && (
                  <p className="error">{errors.comment.message}</p>
                )}
              </div>

              <div className="py-3 d-flex justify-content-center align-items-center">
                <button type="submit" className="btn btn-primary btn-xs ">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>

      {/* Add site TImeline modal  ends here*/}

      {/* Add Time for Site time line modal starts here */}
      <Modal
        size={modalSize ? modalSize : "xl"}
        show={siteTimelineTable}
        onHide={() => setSiteTimelineTable(false)}
        aria-labelledby="example-modal-sizes-title-xl"
        backdrop="static"
      >
        <Modal.Header className="CommonModalHeader">
          <Modal.Title id="example-modal-sizes-title-xl ">
            <h4 className="CommonModalHeaderHeading">{Header}</h4>
            <Button
              variant=""
              className="close CommonModalClose"
              onClick={() => {
                setSiteTimelineTable(false);
              }}
            >
              <span className="CommonModalClose">&times;</span>
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ backgroundColor: "white", padding: "0px !important" }}
        >
          <>
            <div style={{ display: "flex", gap: "5px",marginBottom:"20px" }}>
              <button
                onClick={() => {
                  setTab("Site Timeline CDU");
                  // dispatch(addSiteTimelineRedu([]))
                  setType("CDU");
                  dispatch(
                    FetchSingleRecordAction2(
                      addSiteTimelineData,
                      ranSupportItem["ranSupportId"],
                      "CDU"
                    )
                  );
                }}
                style={{
                  backgroundColor: tab === "Site Timeline CDU" ? "#F16722" : "",
                }}
                className="btn btn-primary btn-xs py-2 px-4 mt-2"
                // disabled={isDisable ? true : false}
              >
                CDU
              </button>

              <button
                onClick={() => {
                  setTab("Site Timeline UPDF");
                  setType("uADPF");
                  dispatch(
                    FetchSingleRecordAction2(
                      addSiteTimelineData,
                      ranSupportItem["ranSupportId"],
                      "uADPF"
                    )
                  );
                }}
                style={{
                  backgroundColor:
                    tab === "Site Timeline UPDF" ? "#F16722" : "",
                }}
                className="btn btn-primary btn-xs py-2 px-4 mt-2"
                // disabled={isDisable ? true : false}
              >
                uADPF
              </button>
            </div>
            {/* <h4>TIMELINE</h4> */}
            {siteTimeline?.timelineData?.data?.length === 0 && (
              <button
                style={{
                  backgroundColor: "#143b64",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginBottom: "15px",
                }}
                // onClick={() => console.log("Button Clicked")}
                onClick={(e) => {
                  setcommonModalStateTimeline(true);
                }}
              >
                Add Site Timeline
              </button>
            )}

            <table className="table">
              <thead>
                <td
                  style={{
                    width: "30%;",
                    paddingTop: "11px",
                    fontSize: "13px",
                    height: "45px",
                    border: "2px solid black",
                  }}
                >
                  S.No.
                </td>
                <td
                  style={{
                    width: "35%;",
                    paddingTop: "11px",
                    fontSize: "13px",
                    height: "45px",
                    border: "2px solid black",
                  }}
                >
                  Team
                </td>
                <td
                  style={{
                    width: "35%;",
                    paddingTop: "11px",
                    fontSize: "13px",
                    height: "45px",
                    border: "2px solid black",
                  }}
                >
                  Activity Timeline
                </td>
                <td
                  style={{
                    width: "35%;",
                    paddingTop: "11px",
                    fontSize: "13px",
                    height: "45px",
                    border: "2px solid black",
                  }}
                >
                  Time
                </td>
                <td
                  style={{
                    width: "35%;",
                    paddingTop: "11px",
                    fontSize: "13px",
                    height: "45px",
                    border: "2px solid black",
                  }}
                >
                  Comment
                </td>
                <td
                  style={{
                    width: "35%;",
                    paddingTop: "11px",
                    fontSize: "13px",
                    height: "45px",
                    border: "2px solid black",
                  }}
                >
                  Action
                </td>
              </thead>
              <tbody>
                {/* {siteTimelineStaticData} */}
                {odata}

                {/* {timelineDataTable.map((item, index) => (
          <tr key={index}>
            <td style={{ border: "2px solid black" }}>{item.id}</td>
            <td style={{ border: "2px solid black" }}>{item.team}</td>
            <td style={{ border: "2px solid black" }}>{item.activity}</td>
            <td style={{ border: "2px solid black" }}>
              
            </td>
            <td style={{ border: "2px solid black" }}></td>
          </tr>
        ))} */}
              </tbody>
              ?
            </table>
            {/* <h4>
          TOTAL ACTIVITY TIME (hrs) - 
          {ranSupportItem?.postCheckDelivered && zeroIndexTime 
            ? getTimeDifference(ranSupportItem?.postCheckDelivered, zeroIndexTime) 
            : "N/A"}
        </h4> */}
          </>
        </Modal.Body>
      </Modal>

      {/* Add Time for Site time line modal e ds here */}
    </>
  );
};

export default SiteTimelineTable;
